class LqdPromoBannerHandler extends elementorModules.frontend.handlers.Base {
  onInit(...args) {
    super.onInit(...args);
    this.initPromoBanner();
  }

  getDefaultSettings() {
    return {
      selectors: {
        bannerElement: '[data-lqd-pb]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $bannerElement: this.$element.find(selectors.bannerElement),
    }
  }

  initPromoBanner() {
    this.elements.$bannerElement.liquidPromoBanner();
  }
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler(LqdPromoBannerHandler, {$element});
};
